import React, { FC } from 'react';

import CheckIcon from '@mui/icons-material/Check';
import Typography from '@mui/material/Typography';

import { useAuth } from '@contexts/common/AuthorizationContext';
import { modalActions } from '@contexts/common/ModalContext';

import { useSwitchChain } from '@hooks/common/useSwitchChain';

import { ConfigChainIds } from '@tools/wagmi';

import ModalWrapper from '@components/common/Modal/ModalWrapper';

import {
  AVAILABLE_CHAINS_LIST,
  CHAIN_INFO,
} from '@constants/common/chain.constants';

import useStyles from './styles.module';

const ChainModal: FC = () => {
  const { classes, cx } = useStyles();
  const { chainId } = useAuth();
  const { switchChain } = useSwitchChain();

  const handleChangeChain = async (id: ConfigChainIds) => {
    await switchChain(id);
    modalActions.hide();
  };

  return (
    <ModalWrapper title="Connect wallet">
      <div className={classes.container}>
        {AVAILABLE_CHAINS_LIST.map((item) => (
          <button
            className={cx(classes.button, {
              [classes.activeButton]: chainId === item,
            })}
            key={item}
            onClick={() => handleChangeChain(item)}
          >
            <div className={classes.row}>
              <img
                src={CHAIN_INFO[item].logo}
                alt=""
                className={classes.logo}
              />
              <Typography variant="subtitle1">
                {CHAIN_INFO[item].name}
              </Typography>
            </div>
            {chainId === item && <CheckIcon />}
          </button>
        ))}
      </div>
    </ModalWrapper>
  );
};

export default ChainModal;
